import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-subtle">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-subtle/60" />}
            {it.to && i < items.length - 1 ? (
              <Link to={it.to} className="transition-colors hover:text-finblue">
                {it.label}
              </Link>
            ) : (
              <span className="font-medium text-ink">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
